import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/** 武四郎アバター（takeshiro_rigged.glb・Narrateアニメ）。ショーケース用の軽量版 */
export class NarratorLite {
  readonly root = new THREE.Group()
  loaded = false
  /** リグ随伴時の定位置（Proto12から戻すときに使用） */
  readonly homePos = new THREE.Vector3(-0.85, 0, -0.95)
  readonly homeRotY = Math.PI * 0.85
  private mixer?: THREE.AnimationMixer

  async load(url: string): Promise<void> {
    if (this.loaded) return
    const gltf = await new GLTFLoader().loadAsync(url)
    const model = gltf.scene
    // 身長1.55mへ正規化・足元を y=0 に
    const b = new THREE.Box3().setFromObject(model)
    const h = Math.max(b.max.y - b.min.y, 0.01)
    model.scale.setScalar(1.55 / h)
    const b2 = new THREE.Box3().setFromObject(model)
    model.position.y -= b2.min.y
    this.root.add(model)
    if (gltf.animations.length > 0) {
      this.mixer = new THREE.AnimationMixer(model)
      const clip = gltf.animations.find((c) => /narrate/i.test(c.name)) ?? gltf.animations[0]
      this.mixer.clipAction(clip).setLoop(THREE.LoopRepeat, Infinity).play()
    }
    this.loaded = true
  }

  /** リグ随伴の定位置へ戻す */
  restoreHome(parent: THREE.Object3D): void {
    this.root.removeFromParent()
    parent.add(this.root)
    this.root.position.copy(this.homePos)
    this.root.rotation.set(0, this.homeRotY, 0)
    this.root.scale.setScalar(1)
  }

  update(dt: number): void {
    this.mixer?.update(dt)
  }
}
